module.exports = "<span (click)='switch()'\n  class='tag'\n  [class.selected]=\"isSelected\">\n  {{label}}\n</span>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/tag-page/tag-page.component.html
// module id = 443
// module chunks = 0